import { Create } from "react-admin";
import { JobApplicationStatusForm } from "./index";

export const JobApplicationStatusCreate = () => (
  <Create>
    <JobApplicationStatusForm />
  </Create>
);
